
import InputText from '../../components/InputText';
import InputSelect from '../../components/InputSelect';
import InputCheckBox from '../../components/InputCheckBox';
import AutoCompleteInput from '../../components/AutoCompleteInput';
import { getLocalities } from '../../utilities/httpRequest';
import { useState, useEffect, useMemo } from "react";
import clsx from "clsx";

export default function Form1({ data, setData, noMail, setNoMail, countries, prescribers, isSuperuser, setActivePrescriber, validationLabel, setValidationLabel }) {

    const [localities, setLocalities] = useState([]);

    const postal = data.petOwner.address.getPostalCodeSync();
    const country = data.petOwner.address.getCountryId();
    useEffect(() => {
        const getLoc = async () => {
            if (data.petOwner.address.getPostalCodeSync().length > 2) {

                const localities = await getLocalities(
                    data.petOwner.address.getPostalCodeSync(),
                    data.petOwner.address.getCountryId()
                );
                setLocalities(localities);
                if (!(localities.map((locality) => locality.id).includes(data.petOwner.address.getLocalityId()))) {
                    data.petOwner.address.setLocalityId(null);
                }
            }
        };
        getLoc();
    }, [postal, country, data.petOwner.address]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            petOwner: prevData.petOwner.handleChange(name, value)
        }))
        setValidationLabel((prevData) => ({
            ...prevData,
            [name]: ""
        }))
    }

    const handleChangeVat = (e) => {
        const { name, value } = e.target;

        if (value.length > 14) {
            return
        }

        let newValue = value.toUpperCase();

        if (newValue.length <= 2) {
            // Les deux premiers caractères : lettres uniquement
            newValue = newValue.replace(/[^A-Z]/g, "");
        } else {
            // Premieres 2 lettres conservées, le reste : chiffres uniquement
            const letters = newValue.slice(0, 2);
            const numbers = newValue.slice(2).replace(/[^0-9]/g, "");
            newValue = letters + numbers;
        }

        const newEvent = {
            target: {
                name,
                value: newValue
            }
        };

        handleChange(newEvent);
    };

    const handleChangeData = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value
        }))
        setValidationLabel((prevData) => ({
            ...prevData,
            [name]: ""
        }))
    }

    const handleFactVete = (e) => {
        const { checked } = e.target;

        setData((prevData) => ({
            ...prevData,
            billingPrescriber: checked
        }));

        if (checked) {
            setValidationLabel((prevData) => ({
                ...prevData,
                street: "",
                street_nb: "",
                country: "",
                postal_code: "",
                box: "",
                locality: ""
            }))
        }

    };

    const handleNoMail = e => {
        const { checked } = e.target;
        if (checked) {
            setNoMail(true);
            handleChange({ target: { name: "email", value: "" } });
        } else {
            setNoMail(false);
        }
    }

    const postalCodeData = useMemo(() => {
        return localities.map((locality) => ({
            id: locality.id,
            label: locality.postal_code + " - " + locality.label,
            searchValue: locality.postal_code,
        }))
    }, [localities])

    const handleChangeLocality = item => {
        const locality = localities.find((locality) => locality.id === item.id);
        handleChange({ target: { name: "locality", value: locality.id } })
        handleChange({ target: { name: "country", value: locality.country } });
        handleChange({ target: { name: "locality_label", value: locality.label } });
        handleChange({ target: { name: "postal_code", value: locality.postal_code } });
    }

    const languageOptions = [
        {
            "id": "FR",
            "label": "Français"
        },
        {
            "id": "NL",
            "label": "Néerlandais"
        },
        {
            "id": "EN",
            "label": "Anglais"
        }
    ]

    return (
        <div className="border-r border-light-gray p-3 basis-2/3">
            <h1 className="text-lg">Propriétaire d'animal</h1>
            <form
                onSubmit={(e) => {
                    e.preventDefault(); // Empêche le rechargement de la page
                }}
            >
                <PrescriberTab className={isSuperuser ? "" : "hidden"} prescribers={prescribers} setActivePrescriber={setActivePrescriber} />
                <div className="flex flex-col gap-2">
                    <h2 className="text-base mt-3">Coordonnées</h2>
                    <div className="flex flex-row gap-2">
                        <InputText validationLabel={validationLabel.name} name="name" value={data.petOwner.name} onChange={handleChange} placeholder="Nom*" />
                        <InputText validationLabel={validationLabel.firstname} name="firstname" value={data.petOwner.firstname} onChange={handleChange} placeholder="Prénom*" />
                    </div>
                    <div className="flex flex-row gap-2">
                        <div className="basis-[35%]"><InputText validationLabel={validationLabel.phone} onChange={handleChange} value={data.petOwner.phone} name="phone" placeholder={"Téléphone" + (isSuperuser ? "" : "*")} /></div>
                        <div className="basis-[45%]"><InputText validationLabel={validationLabel.email} name="email" value={data.petOwner.email} onChange={handleChange} placeholder={"Email" + (noMail ? "" : "*")} disabled={noMail} label="Cette adresse mail sera utilisée pour le suivi administratif de la demande." /></div>
                        <div className="basis-[20%]"><InputSelect validationLabel={validationLabel.language} options={languageOptions} placeholder={"Langue"} name="language" defaultValue={data.petOwner.language} onChange={handleChange} label="Communications et résultats" /></div>
                    </div>
                    <InputCheckBox name="mail-empty" onChange={handleNoMail} checked={noMail} label="Le propriétaire ne posséde pas d'adresse mail pour le suivi de la demande." />
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-base mt-3">Adresse de facturation</h2>
                    <InputCheckBox name="billingPrescriber" checked={data.billingPrescriber} onChange={handleFactVete} label="Facturation au vétérinaire" />

                    <div className={data.billingPrescriber ? "hidden" : "flex flex-row gap-2"}>
                        <InputText validationLabel={validationLabel.vat} name="vat" value={data.petOwner.vat} onChange={handleChangeVat} placeholder="Numéro de TVA" />
                        <InputText validationLabel={validationLabel.companyName} name="company_name" value={data.petOwner.company_name} onChange={handleChange} placeholder="Société" />
                    </div>
                    <div className={data.billingPrescriber ? "hidden" : "flex flex-row gap-2"}>
                        <div className="flex flex-row gap-2 basis-1/2">
                            <InputSelect validationLabel={validationLabel.country} options={countries} placeholder={"Pays" + (data.billingPrescriber ? "" : "*")} name="country" defaultValue={data.petOwner.address.getCountryId()} onChange={handleChange} />
                            <AutoCompleteInput maxHeight={150} data={postalCodeData} validationLabel={validationLabel.postal_code} value={data.petOwner.address.getPostalCodeSync()} name="postal_code" onChange={handleChange} onSelect={handleChangeLocality} placeholder={"Code Postal" + (data.billingPrescriber ? "" : "*")} />
                        </div>
                        <div className="basis-1/2"><InputSelect options={localities} validationLabel={validationLabel.locality} name="locality" defaultValue={data.petOwner.address.getLocalityId()} onChange={handleChange} placeholder={"Localité" + (data.billingPrescriber ? "" : "*")} /></div>
                    </div>
                    <div className={data.billingPrescriber ? "hidden" : "flex flex-row gap-2"}>
                        <div className="basis-[70%]"><InputText validationLabel={validationLabel.street} name="street" value={data.petOwner.address.street} onChange={handleChange} placeholder={"Rue" + (data.billingPrescriber ? "" : "*")} /></div>
                        <div className="basis-[15%]"><InputText validationLabel={validationLabel.street_nb} name="street_nb" value={data.petOwner.address.street_nb} onChange={handleChange} placeholder={"N°" + (data.billingPrescriber ? "" : "*")} /></div>
                        <div className="basis-[15%]"><InputText validationLabel={validationLabel.box} name="postal_box" value={data.petOwner.address.postal_box} onChange={handleChange} placeholder="Boîte" /></div>
                    </div>

                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-base mt-3">Contact pour copie (confrère / consoeur)</h2>
                    <div className="flex flex-row gap-2">
                        <InputText validationLabel={validationLabel.result_copy_name} name="result_copy_name" value={data.result_copy_name} onChange={handleChangeData} placeholder="Nom" label="Une copie des résultats sera envoyée par courriel au vétérinaire désigné." />
                        <InputText validationLabel={validationLabel.result_copy_mail} name="result_copy_mail" value={data.result_copy_mail} onChange={handleChangeData} placeholder="Email" />
                    </div>
                </div>
                <p className="text-sm text-gray mt-2">*Champs obligatoires</p>
            </form>
        </div>
    );
}

const PrescriberTab = ({ prescribers, setActivePrescriber, className }) => {

    const [searchValue, setSearchValue] = useState('')

    const options = useMemo(() => {
        return prescribers.map((item) => (
            {
                id: item.id,
                label: item.individual.first_name + " " + item.individual.last_name + " - " + item.individual.email,
                searchValue: item.individual.first_name + " " + item.individual.last_name + " - " + item.individual.email
            })
        )

    }, [prescribers])

    const handleChangePrescriber = (prescriber) => {
        const prescriberValue = prescribers.find((item) => Number.parseInt(item.id) === Number.parseInt(prescriber.id)) || '';
        if (prescriberValue) {
            setActivePrescriber(prescriberValue);
            setSearchValue(prescriberValue.individual.first_name + " " + prescriberValue.individual.last_name + " - " + prescriberValue.individual.email);
        }

    }

    return (
        <div className={clsx(className, "flex flex-col gap-2")}>
            <h2 className="text-base mt-3">Prescripteur</h2>
            <div className="flex flex-row gap-2">
                <AutoCompleteInput data={options} onChange={(e) => setSearchValue(e.target.value)} onSelect={handleChangePrescriber} value={searchValue} placeholder="Recherche..." />
            </div>
        </div>
    )

}